---
de:
  activemodel:
    attributes:
      green_months_bulk_update_form:
        from_month: Von (Monat)
        realized_price: Preis (NOK/MWh)
        to_month: Bis (Monat)
  errors:
    messages:
      from_month_should_not_be_after_to_month: Von (Monat) sollte nicht nach Bis (Monat) sein
  green_months:
    actions: Aktionen
    available_years: Verfügbare Jahre
    header: Realisierte %{type} für %{power_plant}
    realized_price: Preis [NOK] pro MWh
    volume: Volumen [MWh]
  green_months_bulk_update_form:
    header: Setze %{type} Preise für einen Zeitraum
  messages:
    bulk_update_executed: Massenaktualisierung ausgeführt
  update_all_green_months:
    header: Realisierte Preise für %{power_plant} %{year}
